import * as React from "react";
import { Pin } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useGetFavoritesQuery, useAddFavoriteMutation, useRemoveFavoriteMutation } from "@/api/files";
import { Item } from "@/types/fse";
import clsx from "clsx";

interface Props {
  item: Item;
}

export const DriveRowButtonsFavorite: React.FC<Props> = ({ item }) => {
  const { data: favorites = [] } = useGetFavoritesQuery();
  const [addFavorite, { isLoading: isAddingFavorite }] = useAddFavoriteMutation();
  const [removeFavorite, { isLoading: isRemovingFavorite }] = useRemoveFavoriteMutation();

  const isFavorited = favorites.some(fav => fav.fs_entry_id === item.id);
  const isFavoriteLoading = isAddingFavorite || isRemovingFavorite;

  const handleFavoriteToggle = async () => {
    try {
      if (isFavorited) {
        await removeFavorite(item.id).unwrap();
      } else {
        await addFavorite({ fs_entry_id: item.id }).unwrap();
      }
    } catch (error) {
      console.error("Failed to toggle favorite:", error);
    }
  };

  return (
    <Button
      variant="ghost"
      size="sm"
      className="h-8 w-8 p-0"
      onClick={handleFavoriteToggle}
      disabled={isFavoriteLoading}
      title={isFavorited ? "Unpin from sidebar" : "Pin to sidebar"}
    >
      <Pin className={clsx("h-4 w-4", isFavorited ? "text-yellow-500" : "text-gray-500 hover:text-yellow-500")} />
    </Button>
  );
};
